import { onLocalFilesSelected } from '../actions/onFilesSelected';
import { CreateAttachmentHandler } from '../types/CreateAttachmentHandler';
import { observer } from 'mobx-react';
import { FilePickerAction, FileSelectionFilter } from 'owa-attachment-filepicker';
import { LocalComputerFilePicker } from 'owa-filepicker';
import * as React from 'react';

export interface AttachmentLocalComputerFilePickerProps {
    fileSelectionFilter?: FileSelectionFilter;
    createAttachmentHandler: CreateAttachmentHandler;
    action: FilePickerAction;
}

@observer
export default class AttachmentLocalComputerFilePicker extends React.Component<
    AttachmentLocalComputerFilePickerProps,
    {}
> {
    private localComputerFilePicker: any;

    render() {
        return (
            <LocalComputerFilePicker
                ref={ref => (this.localComputerFilePicker = ref)}
                onFilesSelected={this.onFilesSelected}
                fileSelectionFilter={this.props.fileSelectionFilter}
            />
        );
    }

    public click() {
        this.localComputerFilePicker.getInnerComponent().click();
    }

    private onFilesSelected = (files: File[]) => {
        const { action, createAttachmentHandler } = this.props;

        const isInline = action === FilePickerAction.Insert;
        const shouldShare = action === FilePickerAction.Share;
        onLocalFilesSelected(createAttachmentHandler, files, isInline, shouldShare);
    };
}
